import { CompassContextType } from '@/src/libs/CompassContext';
import userPin from '@/public/images/user-pin.svg';
import placePin from '@/public/images/place-pin.svg';

export const createUtilityMarker = async (
  location: google.maps.LatLngLiteral,
  ctx: CompassContextType,
  type: 'user' | 'place'
) => {
  if (!location) throw new Error('No location provided');
  if (!ctx) throw new Error('No context provided');
  if (!ctx.state?.map) throw new Error('No map provided');

  if (type === 'user' && ctx.state.userMarker) {
    ctx.state.userMarker.map = null;
  }

  if (type === 'place' && ctx.state.placeMarker) {
    ctx.state.placeMarker.map = null;
  }

  //@ts-expect-error - This is definitely in library
  const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

  if (!AdvancedMarkerElement)
    throw new Error('Error loading AdvancedMarkerElement');

  const image = document.createElement('img');
  image.src = type === 'user' ? userPin.src : placePin.src;
  const size = type === 'user' ? 36 : 24;
  image.width = size;
  image.height = size;
  image.alt = type === 'user' ? 'Your location pin' : 'Searched place pin';

  const marker = new AdvancedMarkerElement({
    map: ctx.state.map,
    position: location,
  });

  marker.content = image;

  if (type === 'user') {
    ctx.dispatch({
      type: 'SET_USER_MARKER',
      payload: marker,
    });
  } else {
    ctx.dispatch({
      type: 'SET_PLACE_MARKER',
      payload: marker,
    });
  }
};
